






























import { Component, Vue, Prop, Ref } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';
import moment, {Moment} from 'moment';
import SelectIssue from '@/components/selectIssue.vue';
import SelectProject from '@/components/selectProject.vue';
import { pubsub, CLOSE_TAG_VIEW_EVENT } from '@/utils/pubsub';
import { disabledDate } from '@/utils/other';
import MarkedEditor from '@/components/marked/markedEditor.vue';
import { AccountModule } from '@/store/modules/account';

type IUpdateRequirementInfo = IRequirement.IModel.IUpdateRequirementInfo;
interface IForm {
  title: string;
  description: string;
  issueId: string;
  urgency: number;
  due: Moment;
  projectId: string;
  projectName: string;
}

@Component({
  components: {
    SelectIssue,
    SelectProject,
    MarkedEditor,
  },
})
export default class EditRequirement extends Vue {
  private submitLoading: boolean = false;
  private includeProjectIds = AccountModule.projects.map((project) => project.id);
  get formTitle() {
    if (this.isCreate) {
      return this.$t('requirement.create');
    } else {
      return `${this.requirementFormInfo.title}`;
    }
  }
  @Ref() private readonly editReqForm!: FormModel;
  @Ref() private readonly selectIssue!: SelectIssue;
  @Ref() private readonly selectProject!: SelectProject;
  private rules = {
    title: [{ required: true, message: () => this.$t('form.required'), trigger: 'blur'}],
    description: [{ required: true, message: () => this.$t('form.required'), trigger: 'blur'}],
    due: [{ required: true, message: () => this.$t('form.required'), trigger: 'change'}],
    issueId: [{ required: true, message: () => this.$t('form.required'), trigger: 'change'}],
    projectId: [{ required: true, message: () => this.$t('form.required'), trigger: 'change'}],
  };
  @Prop({default: true}) private isCreate!: boolean;
  @Prop({required: true}) private requirementFormInfo!: IUpdateRequirementInfo;
  @Prop({ required: true }) private submit!: (
    updateInfo: IUpdateRequirementInfo,
  ) => Promise<string>;
  private form: IForm = {
    title: '',
    description: '',
    issueId: '',
    urgency: 0,
    due: moment(),
    projectId: '',
    projectName: '',
  };
  private disabledDate = disabledDate;
  private created() {
    this.initFormData();
  }
  private initFormData() {
    const {title, description, issueId, urgency, due, projectId, projectName} = this.requirementFormInfo;
    this.form = {
      title,
      description,
      issueId,
      urgency,
      due: moment(due),
      projectId,
      projectName,
    };
    this.$nextTick(() => {
      if (this.form.issueId) {
        this.selectIssue.searchIssueById(this.form.issueId);
      }
    });
  }
  private handleSubmit() {
    this.editReqForm.validate((valid) => {
      if (valid) {
        const {description, due, issueId, projectId, title, urgency, projectName} = this.form;
        const dueValue = due.format('YYYY-MM-DD');
        const updateInfo: IUpdateRequirementInfo = {
          title,
          description,
          urgency,
          due: dueValue,
          issueId,
          projectId,
          projectName,
        };
        this.submitRequirement(updateInfo);
      } else {
        return false;
      }
    });
  }
  private submitRequirement(updateInfo: IUpdateRequirementInfo) {
    this.submitLoading = true;
    this.submit(updateInfo).then((res) => {
      this.$message.success(res);
    }).catch((err) => {
      this.$message.warning(err);
    }).finally(() => {
      this.submitLoading = false;
    });
  }
  private goBack() {
    pubsub.publish(CLOSE_TAG_VIEW_EVENT, this.$route.path);
    this.$router.push({name: 'Requirement'});
  }
  private handleIssueChange(issueInfo: IIssue.IResponse.IIssueInfo) {
    if (issueInfo) {
      this.form.issueId = issueInfo.id;
      this.form.title = `#${issueInfo.num}-${issueInfo.title}`;
    } else {
      this.form.issueId = '';
    }
  }
  private handleProjectChange(projectInfo: IProject.IResponse.IProjectInfo) {
    if (projectInfo) {
      this.form.projectId = projectInfo.id;
      this.form.projectName = projectInfo.name;
    } else {
      this.form.projectId = '';
      this.form.projectName = '';
    }
  }
  private updateDescription(description: string) {
    this.form.description = description;
  }
}
